import { Status, StatusColour } from "src/types";

export const statusColorMap: Record<Status, StatusColour> = {
  Draft: "grey",
  Scheduled: "orange",
  "In Progress": "blue",
  Complete: "green",
  Cancelled: "red",
  TBC: "grey",
  "In Review": "orange",
  Confirmed: "green",
  Overdue: "red",
  Voided: "grey",
  Flagged: "red",
  Resolved: "green",
  Closed: "grey",
  Provisioned: "grey",
  Active: "green",
  Deactivated: "red",
  "GXO Error": "red",
  "AA Error": "red",
  Approved: "green",
  "In Transit": "blue",
  "Partially Received": "green",
  Pending: "orange",
  "Under Review": "blue",
  Awaiting: "orange",
  Rejected: "red",
  Partial: "yellow",
  Negotiated: "purple",
  Canceled: "red",
  Open: "blue",
  DRAFT: "grey",
  IN_PROGRESS: "blue",
  COMPLETE: "green"
};

export const statusLabelMap: Partial<Record<Status, string>> = {
  DRAFT: "Draft",
  IN_PROGRESS: "In Progress",
  COMPLETE: "Complete"
};
